import React, {useState, useEffect, useRef} from 'react';
import {useHistory, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Button} from "primereact/button";
import {SplitButton} from "primereact/splitbutton";
import {Dropdown} from "primereact/dropdown";
import axios from "axios";
import download from "js-file-download";

const OfferListComponent = (props) => {

  const {t} = props;
  const history = useHistory();
  const {entity} = useParams();
  const [offers, setOffers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const LIST_STORAGE_KEY = 'lastOfferListState';
  const DEFAULT_SORT_FIELD = 'created_at';
  const DEFAULT_SORT_ORDER = -1;
  const savedListState = localStorage.getItem(LIST_STORAGE_KEY)
    ? JSON.parse(localStorage.getItem(LIST_STORAGE_KEY))
    : null;
  const [rows, setRows] = useState(
    savedListState?.rows || Number(process.env.REACT_APP_LIST_ROW_DEFAULT)
  );
  const [statusDict, setStatusDict] = useState({});
  const dt = useRef(null);
  const defaultFilters = {
    name: { value: null, matchMode: 'contains' },
    offer_number: { value: null, matchMode: 'contains' },
    status: { value: null, matchMode: 'contains' },
    partner_name: { value: null, matchMode: 'contains' },
    'created_by.name': { value: null, matchMode: 'contains' },
    'project_type.name': { value: null, matchMode: 'contains' },
    'partner_contact.name': { value: null, matchMode: 'contains' },
  };

  const [lazyParams, setLazyParams] = useState(() => {
    const savedLazyParams = savedListState?.lazyParams;
    if (savedLazyParams) {
      return {
        ...savedLazyParams,
        first: savedLazyParams.first ?? 0,
        rows: savedLazyParams.rows ?? rows,
        page: savedLazyParams.page ?? 0,
        sortField: savedLazyParams.sortField || DEFAULT_SORT_FIELD,
        sortOrder: typeof savedLazyParams.sortOrder === 'number' ? savedLazyParams.sortOrder : DEFAULT_SORT_ORDER,
        filters: {
          ...defaultFilters,
          ...(savedLazyParams.filters || {})
        }
      };
    }
    return {
      first: 0,
      rows: rows,
      page: 0,
      sortField: DEFAULT_SORT_FIELD,
      sortOrder: DEFAULT_SORT_ORDER,
      filters: defaultFilters,
    };
  });

  let loadLazyTimeout = null;
  const loadLazyData = () => {
    setLoading(true);
    if (loadLazyTimeout) {
      clearTimeout(loadLazyTimeout);
    }
    loadLazyTimeout = setTimeout(() => {
      const lazyParamsWithoutFilters = {
        ...lazyParams,
        filters: {}
      };
      let query = window.App.transformQueryParams(lazyParamsWithoutFilters);
      const filterQuery = buildFilterQuery(lazyParams.filters);
      if (filterQuery) {
        query += `${query.includes('?') ? '&' : '?'}${filterQuery}`;
      }
      apiCall('get', '/api/v2/offer' + query)
        .then(response => {
          setTotalRecords(response.data.data.total_item_count);
          setOffers(response.data.data.items)
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }, Math.random() * 1000 + 250);
  }
  const onPage = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onSort = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onFilter = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    _lazyParams['first'] = 0;
    _lazyParams['page'] = 0;
    setLazyParams(_lazyParams);
  }
  const pager = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        {label: Number(process.env.REACT_APP_LIST_ROW_OP1), value: Number(process.env.REACT_APP_LIST_ROW_OP1)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP2), value: Number(process.env.REACT_APP_LIST_ROW_OP2)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP3), value: Number(process.env.REACT_APP_LIST_ROW_OP3)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP4), value: Number(process.env.REACT_APP_LIST_ROW_OP4)},
      ];

      return (
        <>
          {/*<span className="p-mx-1" style={{color: 'var(--text-color)', userSelect: 'none'}}>Tételek egy oldalon: </span>*/}
          <Dropdown value={options.value} options={dropdownOptions} onChange={(e) => setRows(e.target.value)}
                    appendTo={document.body}/>
        </>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center'}}>
                        {options.first} - {options.last} / {options.totalRecords}
        </span>
      )
    }
  };

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }

  const actionBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        <SplitButton icon="pi pi-file-pdf" label="PDF" className="p-button-secondary p-mr-2"
                tooltip={t('downloadPdf')} tooltipOptions={{position: 'left'}}
                onClick={() => downloadOffer(rowData, 'pdf')}
                model={downloadLanguageOptions(rowData, 'pdf')}
        />
        
        <SplitButton icon="pi pi-file-excel" label="XLSX" className="p-button-secondary p-mr-2"
                tooltip={t('downloadXlsx')} tooltipOptions={{position: 'left'}}
                onClick={() => downloadOffer(rowData, 'xlsx')}
                model={downloadLanguageOptions(rowData, 'xlsx')}
        />
        
        {localStorage.getItem('roles').toString().includes('role_offer_write') &&
          <Button icon="pi pi-pencil" className="  p-button-warning p-mr-2"
                  tooltip={t('edit')} tooltipOptions={{position: 'left'}}
                  disabled = {rowData.status === 'SENT' || rowData.status === 'ACCEPTED'}
                  onClick={() => {
                    if (entity === 'offer') {
                      history.push('/project/offer/update/' + rowData.id)
                    }
                  }}/>
        }
        <Button icon="pi pi-eye" className=" p-button p-mr-2"
                tooltip={t('view')} tooltipOptions={{position: 'left'}}
                onClick={() => {
                  history.push('/project/offer/read/' + rowData.id)
                }}
        />
        {localStorage.getItem('roles').toString().includes('role_offer_write') &&
          <Button icon="pi pi-trash" className="p-button-danger"
                  tooltip={t('delete')} tooltipOptions={{position: 'left'}}
                  onClick={() => {
                    if (window.confirm('A törlés megerősítésére van szükség!')) {
                      setLoading(true);
                      apiCall('delete', '/api/v2/offer/' + rowData.id)
                        .then(response => {
                          window.App.toastShow('success', 'Sikeres törlés!');
                          window.App.setState({rerenderOfferList: Math.random()})
                        })
                        .catch(error => {
                          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                        })
                        .finally(() => {
                          setLoading(false);
                        })
                    }
                  }}
          />
        }
      </React.Fragment>
    );
  }

  const buildFilterQuery = (filters) => {
    const parts = [];
    Object.entries(filters || {}).forEach(([field, config]) => {
      if (!config || config.value === null || config.value === undefined || config.value === '') {
        return;
      }
      if (config.matchMode === 'equals') {
        parts.push(`search[${field}][operator]==`);
        parts.push(`search[${field}][value]=${encodeURIComponent(config.value)}`);
      } else {
        parts.push(`search[${field}][operator]=like`);
        parts.push(`search[${field}][value]=${encodeURIComponent('*' + config.value + '*')}`);
      }
    });
    return parts.join('&');
  };

  const downloadLanguageOptions = (rowData, format) => [
    {
      label: t('downloadHungarianVersion'),
      icon: 'pi pi-download',
      command: () => downloadOffer(rowData, format, 'hu')
    },
    {
      label: t('downloadEnglishVersion'),
      icon: 'pi pi-download',
      command: () => downloadOffer(rowData, format, 'en')
    }
  ];

  const downloadOffer = async (rowData, format, locale = null) => {
    setLoading(true);
    try {
      const offerId = rowData.id;
      const filenameBase = rowData.offer_number || rowData.name || `offer-${offerId}`;
      const res = await axios.get(
        process.env.REACT_APP_API_HOST + `/api/v2/offer/${offerId}/download/${format}`,
        {
          responseType: 'blob',
          params: locale ? { locale } : {},
          headers: {
            'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
            'App-Network': localStorage.getItem("networkId")
          }
        }
      );
      download(res.data, filenameBase + (locale ? '_' + locale : '') + '.' + format);
    } catch (error) {
      window.App.toastShow('error', t('error'), error.toString(), '', error?.response);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    axios.get(process.env.REACT_APP_API_HOST + '/api/v2/dictionary/offer-status', {
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
      .then(response => {
        setStatusDict(response.data.data);
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      });
  }, []);

  useEffect(() => {
    localStorage.setItem(LIST_STORAGE_KEY, JSON.stringify({
      rows,
      lazyParams,
      sortField: lazyParams.sortField || 'created_at',
      sortOrder: typeof lazyParams.sortOrder === 'number' ? lazyParams.sortOrder : -1,
    }));
  }, [rows, lazyParams]);

  useEffect(() => {
    setLazyParams((prev) => ({
      ...prev,
      rows: rows
    }));
  }, [rows]);

  useEffect(() => {
    loadLazyData();
  }, [lazyParams, window.App.state.rerenderOfferList])

  return (
    <>
      <DataTable size={localStorage.getItem('scale')}
                 emptyMessage={t('noResults')}
                 value={offers} paginator first={lazyParams.first} totalRecords={totalRecords} onPage={onPage}
                 onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
                 onFilter={onFilter} filters={lazyParams.filters} loading={loading} lazy
                 paginatorTemplate={pager} rows={lazyParams.rows}
                 autoLayout={true}
                 filterDisplay="row"
                 responsiveLayout="scroll"
                 stripedRows
                 ref={dt}
                 dataKey="id"
      >
        <Column field="offer_number" header={t('projectNumber')} bodyClassName="col-body-font-bold" sortable filter></Column>
        <Column field="partner.name" header={t('columnPartner')} sortable filter filterField='partner_name'></Column>
        <Column field="name" header={t('columnName')} bodyClassName="col-body-font-bold" sortable filter></Column>
        <Column field="project_type.name" header={t('columnType')} filter></Column>
        <Column field="status" header={t('columnStatus2')} filter body={(rowData) => {
          const statusItem = Array.isArray(statusDict)
            ? statusDict.find(item => item.key === rowData.status)
            : null;

          return (
            <>
              {statusItem?.value || rowData.status}
            </>
          )
        }}></Column>
        <Column field="net_amount" header={t('offerNetTotal')} sortable className="p-text-right" body={(rowData) => {
          if (rowData?.project_type?.continuous_fulfillment) {
            return <span style={{color: '#9ca3af'}}>&mdash;</span>;
          }

          return window.App.currencyFormatter(rowData?.currency || 'HUF', rowData.net_amount);
        }}></Column>
        <Column field="quotation_deadline" header={t('offerQuotationDeadline')} body={(rowData) => {
          return (
            <>{window.App.formatDateValue(rowData.quotation_deadline)}</>
          )
        }}></Column>
        <Column field="partner_contact.name" header={t('columnContactPerson')} filter></Column>
        <Column field="created_at" header={t('columnCreatedAt')} sortable body={(rowData) => {
          return (
            <>{window.App.formatDateValue(rowData.created_at)}</>
          )
        }}></Column>
        <Column field="created_by.name" header={t('columnCreatedBy')} filter></Column>
        <Column field="updated_at" header={t('columnUpdatedAt')} sortable body={(rowData) => {
          return (
            <>{window.App.formatDateValue(rowData.updated_at)}</>
          )
        }}></Column>
        <Column body={actionBodyTemplate} className={"p-py-0 p-text-right p-text-nowrap"}></Column>
      </DataTable>
    </>
  )
}
export default withTranslation('common')(OfferListComponent);
